export default __webpack_public_path__ + "static/media/competition_bar_right.3f4cac53.png";